import React from "react";

export const PR_CYAN = "#00F0FF";
export const PR_GOLD = "#FFD700";

export function SpinFrame({ color, alt, className = "", children }) {
  return (
    <div className={`relative rounded-2xl p-[3px] overflow-hidden ${className}`} style={{ boxShadow: `0 0 28px ${color}88` }}>
      <div className="absolute -inset-1/2" style={{ background: `conic-gradient(from 0deg, ${color}, ${alt}, ${color}, #FFFFFF, ${color})`, animation: "wrSpin 5s linear infinite" }} />
      <div className="relative w-full h-full rounded-[13px] overflow-hidden bg-[#0A051A]">{children}</div>
    </div>
  );
}

export function HeroStat({ icon: Icon, label, color, testId, value, delay = 0 }) {
  return (
    <div className="wr-rise group relative overflow-hidden rounded-xl p-[2px]" style={{ background: `linear-gradient(140deg, ${color}, #5B3BFF55, ${color}66)`, animationDelay: `${delay}ms` }}>
      <div className="relative h-full rounded-[10px] bg-[#0A051A]/85 backdrop-blur px-3 py-2.5">
        <div className="pointer-events-none absolute -right-5 -top-5 w-16 h-16 rounded-full blur-2xl opacity-30 transition-opacity duration-300 group-hover:opacity-70" style={{ background: color }} />
        <Icon size={42} strokeWidth={1.6} className="pointer-events-none absolute -right-1 -bottom-2 opacity-15 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6" style={{ color }} />
        <div className="relative flex items-center gap-1.5">
          <Icon size={14} strokeWidth={2.6} style={{ color, filter: `drop-shadow(0 0 5px ${color})` }} />
          <span className="text-[10px] uppercase tracking-[0.2em] font-mono text-[#C9BDF0]">{label}</span>
        </div>
        <div className="relative mt-1 lb-num font-bold text-2xl leading-none" style={{ color, textShadow: `0 0 10px ${color}88` }} data-testid={testId}>{value}</div>
      </div>
    </div>
  );
}

export function CapacityBar({ count, cap }) {
  return (
    <div data-testid="promotion-capacity-bar">
      <div className="flex justify-between text-[10px] font-mono uppercase tracking-[0.2em] text-[#C9BDF0] mb-1">
        <span>Roster Capacity</span><span className="lb-num font-bold text-[#FFE600]">{count}/{cap}</span>
      </div>
      <div className="flex gap-1">
        {Array.from({ length: cap }).map((_, i) => (
          <div key={i} className="pr-seg h-2 flex-1 rounded-full" style={i < count
            ? { background: "linear-gradient(90deg, #FF007F, #FFE600)", boxShadow: "0 0 8px #FF007F88", animationDelay: `${i * 60}ms` }
            : { background: "#2D1C52" }} />
        ))}
      </div>
    </div>
  );
}

export function NeonBtn({ color, icon: Icon, children, testId, onClick, disabled, title }) {
  return (
    <button data-testid={testId} onClick={onClick} disabled={disabled} title={title}
            className="group relative overflow-hidden inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl border-2 font-heading text-xs uppercase tracking-widest text-white transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 active:scale-95 disabled:opacity-40 disabled:pointer-events-none"
            style={{ borderColor: color, background: `linear-gradient(180deg, ${color}40, ${color}10 70%, #0A051A)`, boxShadow: `0 0 14px ${color}55` }}>
      <span className="wr-tile-shine pointer-events-none absolute inset-y-0 -left-1/2 w-1/3 opacity-0 group-hover:opacity-100 group-hover:animate-[wrTileShine_0.7s_ease-out]" />
      {Icon && <Icon size={15} strokeWidth={2.6} style={{ color, filter: `drop-shadow(0 0 4px ${color})` }} />}
      <span className="relative">{children}</span>
    </button>
  );
}

export function IconBtn({ color, icon: Icon, testId, onClick, disabled, title }) {
  return (
    <button data-testid={testId} onClick={onClick} disabled={disabled} title={title}
            className="p-2 rounded-lg border-2 transition-[transform,background-color,box-shadow] duration-150 hover:scale-110 active:scale-95 disabled:opacity-40"
            style={{ borderColor: color, color, background: `${color}1F`, boxShadow: `0 0 10px ${color}44` }}>
      <Icon size={16} strokeWidth={2.8} />
    </button>
  );
}
